import React, { memo } from "react"
import { DeterministicNode as DeterministicNodeType } from "@features/builder/graph/types"
import NodeContainer from "@features/builder/graph/nodes/NodeContainer"

export const DeterministicNode = memo((node: DeterministicNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-deterministic">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

DeterministicNode.displayName = "DeterministicNode"
